import { XHR, getHeaders } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

function getBaseUrl() {
  return OlsConfigStore.getApiBaseUrl();
}

function checkoutUrl(order) {
  return `${getBaseUrl()}/api/checkouts/${order.number}?app=vnext`;
}

export function updateCartShipAddress(order, shippingContact) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(checkoutUrl(order),
    {
      state: 'address',
      order: {
        alternative_attributes: {
          apple_pay: {
            email: null,
            ship_address_attributes: shippingContact,
            bill_address_attributes: 'same_as_ship_address'
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function updateCartShipMethod(order, shippingMethod) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(checkoutUrl(order),
    {
      order: {
        alternative_attributes: {
          apple_pay: {
            shipments_attributes: {
              selected_shipping_rate_id: shippingMethod.identifier
            }
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function completeOrder(order, shippingContact, token, initPage) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(checkoutUrl(order),
    {
      order: {
        payment_init_page: initPage,
        payments_attributes: [{
          payment_method_list_type: 'apple'
        }],
        alternative_attributes: {
          apple_pay: {
            email: shippingContact.emailAddress,
            ship_address_attributes: shippingContact,
            bill_address_attributes: token.card,
            payments_attributes: token
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}
